import styled from 'styled-components';
import WithDirection from '../../../config/withDirection';

export default WithDirection(styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    justify-self: flex-start;
    margin: 0 14px;

    .app-logo-container { margin-right: 24px; min-width: 68px; width: 68px; height: 68px; }
    .app-logo-container img { width: 100%; height: 100%; border-radius: 16px; }

    .info-container { display: flex; flex-direction: column; justify-content: space-around; }
    .app-name, .app-information {
        font-family: 'Montserrat';
        font-weight: 300;
        font-size: 22px;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 0.09em;
    }
    .app-information { font-size: 14px; }

    @media screen and (max-width: 767px) {
        margin: 0;

        .app-logo-container { margin: 0; min-width: 50px; width: 50px; height: 50px; }
        .app-logo-container img { border: 1px solid rgba(255, 255, 255, .4); border-radius: 10px; }
        .info-container { display: none; }
    }
`);


// WEBPACK FOOTER //
// ./src/components/Headers/AppInfo/Wrapper.js